export default __webpack_public_path__ + "static/media/2174.19ff8f4e.png";